import { Navigate, useLocation } from "react-router-dom";

export default function RootEntry() {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  return <Navigate to={params.get("app") === "food" ? "/food" : "/inicio"} replace />;
}
